import { render, staticRenderFns } from "./ErrorStep.vue?vue&type=template&id=50f188e4"
import script from "./ErrorStep.vue?vue&type=script&lang=js"
export * from "./ErrorStep.vue?vue&type=script&lang=js"
import style0 from "./ErrorStep.vue?vue&type=style&index=0&id=50f188e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ErrorStep.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports